export default {
  methods: {
    multiselectFlagState(lang) {
      return lang ? "multiselect__iconBox" : "";
    }
  }
};
